import { useNavigate } from "react-router-dom"

const radio = { borderRadius: '5px', fontWeight: '500' }
function AddArtista() {
    const navigate = useNavigate()
    return (
        <>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', marginTop: '3em', gap: '18px', fontSize: 'medium' }}>
                <button style={radio} onClick={() => { navigate('/addArtista') }}>AGGIUNGI UN ARTISTA
                </button>
                <button style={radio} onClick={() => { navigate('/addFoodTruck') }}>AGGIUNGI UN FOODTRUCK
                </button>
                <button style={radio} onClick={() => { navigate('/addFornitore') }}>AGGIUNGI ALLESTIMENTO</button>
            </div>
        </>
    )
}
export default AddArtista